// константы для формирования путей для Router
export const NEW = 'new';

// main app
export const LOGIN = 'login';
export const STATIONS = 'stations';
export const REPORTS = 'reports';
export const USERINFO = 'userinfo';
export const NOTIFICATIONS = 'notifications';
export const SETTINGS = 'settings';
export const FILES = 'files';

// станция/источник
export const DATA = 'data';
export const CONFINES = 'confines';
export const CHANNELS = 'channels';
export const DATASOURCES = 'datasources';
export const DEVICES = 'devices';
export const DEVICE_DETECTOR = 'device-detector';
export const FORMS = 'forms';
export const MESSAGES = 'messages';
export const MONITOR = 'monitor';
export const OBSERVATIONS = 'observations';
export const PASSPORT = 'passport';
export const PROFILE = 'profile';
export const SEND_MESSAGE = 'send-message';
export const TELEGRAMS = 'telegrams';
export const TERMINAL = 'terminal';
export const TIMESERIES_DATA = 'timeseries-data';
export const SEBA_MAPPING = 'seba-mapping';

// настройки
export const SETTINGS_PATHS = {
  telegramType: 'telegram-type',
  hModels: 'h-models',
};
